const locale = process.env.VUE_APP_LOCALE;

export const APP_CONFIG = {
  locale,
  appName: process.env.VUE_APP_NAME_TH,
  appNameEN: process.env.VUE_APP_NAME_EN,
};
